import { render } from "./GlobalErrorModal.vue?vue&type=template&id=8d42f3ba&scoped=true"
import script from "./GlobalErrorModal.vue?vue&type=script&lang=js"
export * from "./GlobalErrorModal.vue?vue&type=script&lang=js"

import "./GlobalErrorModal.vue?vue&type=style&index=0&id=8d42f3ba&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d42f3ba"]])

export default __exports__